import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { APPLICANT_TYPE } from "tagTypes";

export const useApplicantTypeQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/applicant-type",
    query,
    tags: [APPLICANT_TYPE],
  });

export const useLazyApplicantTypeQuery = () => {
  const [getApplicantType, data] = useLazyGetQuery();
  const applicantType = async (query = {}) =>
    await getApplicantType(
      {
        endpoint: "/applicant-type",
        query,
        tags: [APPLICANT_TYPE],
      },
      true
    ).unwrap();
  return [applicantType, data];
};

export const usePostApplicantTypeMutation = () => {
  const [applicantType, data] = usePostMutation();
  const addApplicantType = async (payload, query = {}) =>
    await applicantType({
      endpoint: "/applicant-type",
      query,
      payload: payload || {},
      toastMessage: "Applicant type added successfully",
      tags: [APPLICANT_TYPE],
    }).unwrap();
  return [addApplicantType, data];
};

export const usePutApplicantTypeMutation = () => {
  const [applicantType, data] = usePutMutation();
  const updateApplicantType = async (payload, id, query = {}) =>
    await applicantType({
      endpoint: `/applicant-type/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Applicant type updated successfully",
      tags: [APPLICANT_TYPE],
    }).unwrap();
  return [updateApplicantType, data];
};

export const useDeleteApplicantTypeMutation = () => {
  const [applicantType, data] = useDeleteMutation();
  const deleteApplicantType = async (id, query = {}) =>
    await applicantType({
      endpoint: `/applicant-type/${id}`,
      query,
      toastMessage: "Applicant type deleted successully",
      tags: [APPLICANT_TYPE],
    }).unwrap();
  return [deleteApplicantType, data];
};
